import { call, put, takeLatest } from 'redux-saga/effects';

import { makeAppointment } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';
import { set } from 'modules/Contacts/redux/appointments/actions';
import { moment } from 'utils';

function* sendData(action) {
  const { data, taxAuthority } = action.payload;
  const response = yield call(makeAppointment, data);
  if (response.isOk) {
    yield put(
      set({
        data: {
          ...response.data,
          serviceName: data.serviceName,
          visitTime: moment.parseZone(data.book.visitTime),
          email: data.book.email,
          taxAuthority,
        },
        bookId: response.data.bookId,
      }),
    );
    yield put(requestSuccess(response.data));
  } else {
    yield put(requestFailure(response.error));
  }
}

export default function* makeAppointmentSaga() {
  yield takeLatest(actionTypes.REQUEST_START, sendData);
}
